import { useEffect, useState } from 'react';
import { getAllComplexFilters } from '../api/complexFilters';

export const useComplexFilters = () => {
  const [filters, setFilters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    getAllComplexFilters()
      .then(setFilters)
      .catch(setError)
      .finally(() => setLoading(false));
  }, []);

  return { filters, loading, error };
};